import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Coquille } from "@app/Coquille";
import { RouteProtegee } from "@features/auth/RouteProtegee";
import { PageConnexion } from "@features/auth/PageConnexion";
import { PageRecherche } from "@features/recherche/PageRecherche";
import { PageProspection } from "@features/prospection/PageProspection";
import { PageFiche } from "@features/fiche/PageFiche";

/** L'admin est chargé à la demande : il ne concerne qu'une poignée de comptes. */
const PageAdmin = lazy(() => import("@features/admin/PageAdmin"));

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/connexion" element={<PageConnexion />} />
        <Route element={<RouteProtegee><Coquille /></RouteProtegee>}>
          <Route path="/" element={<Navigate to="/recherche" replace />} />
          <Route path="/recherche" element={<PageRecherche />} />
          <Route path="/prospection" element={<PageProspection />} />
          <Route path="/prospects/:id" element={<PageFiche />} />
          <Route path="/admin/*" element={
            <RouteProtegee role="admin">
              <Suspense fallback={<p className="etat">Chargement de l'administration…</p>}>
                <PageAdmin />
              </Suspense>
            </RouteProtegee>
          } />
        </Route>
        <Route path="*" element={<p className="etat">Page inconnue. <a href="/recherche">Revenir à la recherche</a></p>} />
      </Routes>
    </BrowserRouter>
  );
}
